import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e7c8170"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-start align-items-start w-100 h-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "file-input",
  class: "align-items-center justify-content-center"
}, [
  /*#__PURE__*/_createTextVNode(" Foto auswählen   "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-images",
    style: {"margin-left":"0.5rem","font-size":"1.5rem"}
  })
], -1))



export default /*#__PURE__*/_defineComponent({
  emits: ["filesSelected"],
  setup(__props, { emit }: { emit: ({
  (e: 'filesSelected', files: File[]):void
}), expose: any, slots: any, attrs: any }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("input", {
      id: "file-input",
      ref: (_value, _refs) => {
        _refs['image'] = _value
      },
      type: "file",
      accept: "image/*",
      name: "cameraInput",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('filesSelected', $event.target.files))),
      style: {"font-size":"0.125rem"}
    }, null, 544)
  ]))
}
}

})